<template>
    <b-modal no-fade ref="dialog" title-tag="h2" title="Submit Order" lazy>
        Once an order is submitted, it will no longer be editable. Are you sure
        want to submit this order?

        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="submit">
                Submit
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";

export default {
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false,
            orderId: null
        };
    },
    methods: {
        open(orderId) {
            this.orderId = orderId;
            this.$refs.dialog.show();
        },
        async submit() {
            try {
                this.isLoading = true;

                let success = await this.$store.dispatch(
                    "inventoryOrder/submitOrder",
                    {
                        orderId: this.orderId
                    }
                );

                if (success) {
                    this.$refs.dialog.hide();
                    this._message("Order submitted successfully.");
                    this.$emit("on-success");
                } else {
                    throw new Error("Unable to submit order.");
                }
            } catch (err) {
                this.isLoading = false;
                this._message(err.message, "danger");
            }
        }
    }
};
</script>
